// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__24vMn","title":"FrontImage_title__Ea3I3"};